/*
 * Copyright (C) 2013-2026 Neckar IT GmbH, Mössingen, Germany
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Linking this library statically or dynamically with other modules is
 * making a combined work based on this library. Thus, the terms and
 * conditions of the GNU General Public License cover the whole combination.
 *
 * As a special exception, the copyright holders of this library give you
 * permission to link this library with independent modules, regardless of
 * the license terms of these independent modules, and to copy and distribute
 * the resulting combined work under terms of your choice, provided that every
 * copy of the combined work is accompanied by a complete copy of the source
 * code of this library.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
package it.neckar.react.common

import it.neckar.common.featureflags.FeatureFlag
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.react.common.featureflags.*
import react.*


/**
 * This component throws an exception
 */
val BuggyComponent: FC<BuggyComponentProps> = fc("BuggyComponent") { props ->
  if (props.throwException == true) {
    throw IllegalStateException(props.message ?: "Exception thrown within BuggyComponent")
  }
}

external interface BuggyComponentProps : Props {
  var throwException: Boolean?
  var message: String?
}

/**
 * Uses the feature flags to decide whether to throw an exception
 */
val BuggyComponentFromFeatureFlags: FC<BuggyComponentFromFeatureFlagsProps> = fc("BuggyComponentFromFeatureFlags") { props ->
  val featureFlag = props.featureFlag ?: FeatureFlag.throwException
  val errorMessage = props::errorMessage.safeGet()

  val featureFlagsContextContent = useFeatureFlagsContext()

  BuggyComponent {
    attrs {
      throwException = featureFlagsContextContent.featureFlags.contains(featureFlag)
      message = errorMessage
    }
  }
}

external interface BuggyComponentFromFeatureFlagsProps : Props {
  var featureFlag: FeatureFlag?
  var errorMessage: String?
}
